/**
 * Lazy-load vault search to avoid pulling db into chat bundle init.
 * Used by ChatInterface when building context for AI messages.
 */
export async function getSearchFunctions() {
  if (typeof window === "undefined") {
    return { searchChunks: async () => [], getChunkSource: async () => "Unknown" };
  }
  try {
    const { searchChunks, getChunkSource } = await import("@/lib/vault/search");
    return { searchChunks, getChunkSource };
  } catch (error) {
    console.warn("Failed to load search functions:", error);
    return { searchChunks: async () => [], getChunkSource: async () => "Unknown" };
  }
}
